import { Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomTable from "../../components/CustomTable/CustomTable";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import AddSpeaker from "./AddSpeaker";

const Speaker = () => {
  const [showAddLeadershipCouncil, setShowAddLeadershipCouncil] =
    useState(false);
  const [leadershipCouncils, setLeadershipCouncils] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [leadershipCouncilToDelete, setLeadershipCouncilToDelete] = useState<
    string | null
  >(null);
  const [leadershipCouncilToEdit, setLeadershipCouncilToEdit] = useState<
    any | null
  >(null);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  useEffect(() => {
    getMediaTags();
  }, [currentPage]);

  const getMediaTags = () => {
    WebService.getAPI({
      action: `speaker/get-list?page=${currentPage}&limit=${itemsPerPage}`,
    })
      .then((res: any) => {
           const perm = res?.data?.permissions || {};
        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        const formattedRows = res?.data?.data.map((item: any) => {
          // ✅ strip HTML
          const stripHtml = (html: string) => {
            if (!html) return "";
            const doc = new DOMParser().parseFromString(html, "text/html");
            return doc.body.textContent || "";
          };

          // ✅ truncate to N words
          const truncateDescription = (text: string, wordLimit = 4) => {
            if (!text) return "";
            const words = text.split(/\s+/);
            return words.length > wordLimit
              ? words.slice(0, wordLimit).join(" ") + "..."
              : text;
          };

          const plainTextDescription = stripHtml(item.description);
          const truncated = truncateDescription(plainTextDescription, 4);

          return {
            ...item,
            description: truncated,
            action: (
              <div>
                 {perm.canEdit && (
                <PencilFill
                  className="me-3 cursor-pointer"
                  onClick={() => {
                    setShowAddLeadershipCouncil(true);
                    setLeadershipCouncilToEdit(item);
                  }}
                  title="Edit"
                /> )}
                {perm.canDelete && (
                <TrashFill
                  color="#DC143C"
                  className="cursor-pointer"
                  onClick={() => handleDeleteEvent(item._id)}
                  title="Delete"
                /> )}
              </div>
            ),
          };
        });
        setLeadershipCouncils(formattedRows);
        setTotalCount(res?.data?.pagination?.total);
      })
      .catch((err: any) => {});
  };

  const handleDeleteEvent = (leadershipCouncilId: string) => {
    setLeadershipCouncilToDelete(leadershipCouncilId);
    setShowDeleteModal(true);
  };

  return (
    <>
      <AddSpeaker
        show={showAddLeadershipCouncil}
        handleClose={() => {
          setShowAddLeadershipCouncil(false);
          setLeadershipCouncilToEdit(null);
          getMediaTags();
        }}
        data={leadershipCouncilToEdit}
      />
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={() => {
          if (leadershipCouncilToDelete) {
            WebService.deleteAPI({
              action: `speaker/delete-speaker/${leadershipCouncilToDelete}`,
            }).then(() => {
              setShowDeleteModal(false);
              getMediaTags();
            });
          }
        }}
        message="Are you sure you want to delete this speaker?"
      />
      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">Speakers</div>
            {pagePermission.canAdd && (
            <CustomButton
              isLoading={false}
              label="Add"
              onClick={() => {
                setLeadershipCouncilToEdit(null);
                setShowAddLeadershipCouncil(true);
              }}
              style={{ width: 100 }}
            /> )}
          </div>
          <CustomTable
            columns={[
              { id: "full_name", label: "Name", minWidth: 170 },
              { id: "position", label: "Position", minWidth: 170 },

              { id: "action", label: "Action", minWidth: 100, align: "center" },
            ]}
            rows={leadershipCouncils}
            totalCount={totalCount}
            currentPage={currentPage}
            pageSize={itemsPerPage}
            onPageChange={(page) => {
              setCurrentPage(page);
            }}
          />
        </Card>
      </div>
    </>
  );
};

export default Speaker;
